// extracted by mini-css-extract-plugin
export default {"container":"SupplierReplacementSelect_container__+AruY","header":"SupplierReplacementSelect_header__dTyvl","buttonWrapper":"SupplierReplacementSelect_buttonWrapper__g3NtR"};